import React from 'react';
import { translate } from '../../i18n';
import ReusableButton from './Button/Button';
import CrossIcon from '../../assets/CrossIcon';
import CrossIconDarkForm from '../../assets/icon/CrossIconForm';
import CheckIcon from '../../assets/CheckIcon';
interface DeleteConfirmationProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  itemName?: string;
  operationStaffId?: number;
  operationBalloonId?: number;
}

const DeleteConfirmation: React.FC<DeleteConfirmationProps> = ({
  isOpen,
  onClose,
  onConfirm,
  itemName,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-500 flex items-center justify-center bg-gray-800 bg-opacity-50">
      <div className=" rounded-lg shadow-lg w-96 p-6 space-y-4  bg-sidebar-background ">
        <h2 className="text-xl font-semibold text-text-secondary text-center">
          {itemName}{' '}
        </h2>
        <p className="text-text-secondary text-center">
          This action cannot be undone. Please confirm your decision.
        </p>

        <div className="flex justify-around space-x-4">
          <ReusableButton
            icon={<CheckIcon />}
            children={'Yes, Delete'}
            variant="primary"
            className="w-auto bg-background-backgroundColor"
            onClick={onConfirm}
          />
          <ReusableButton
            variant="secondary"
            children={'Cancel'}
            icon={
              <div>
                <div className="block dark:hidden">
                  <CrossIcon />
                </div>
                <div className="hidden dark:block">
                  <CrossIconDarkForm />
                </div>
              </div>
            }
            onClick={onClose}
            className="w-auto bg-button-cancelButtonBgColor text-text-cancelButtonTextColor"
          />
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmation;
